export default __webpack_public_path__ + "static/media/profile.a49f33d0.svg";